<template>
  <div class="v2-card v2-dashboard-welcome">
    <img
      v-if="profile.logo"
      :src="profile.logo"
      :alt="entityName"
      class="v2-welcome-logo"
    >
    <kingpin-logo
      v-else
      class="v2-welcome-logo v2-welcome-logo-fallback"
    />
    <div class="v2-welcome-text">
      <p class="v2-text-sm v2-text-muted v2-welcome-greeting">
        Welcome back,
      </p>
      <h2 class="v2-heading-md v2-welcome-name">
        {{ entityName }}
      </h2>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import store from '@/store'
import KingpinLogo from '@core/layouts/components/Logo.vue'

export default {
  name: 'V2DashboardWelcomeCard',
  components: { KingpinLogo },
  props: {
    currentAssociation: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const profile = computed(() => store.getters.profile || {})
    const entityName = computed(
      () => props.currentAssociation?.entity?.entityName || '',
    )
    return { profile, entityName }
  },
}
</script>

<style lang="scss" scoped>
.v2-dashboard-welcome {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
}

.v2-welcome-logo {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid var(--v2-border);
}

.v2-welcome-logo-fallback {
  background: var(--v2-card);
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v2-welcome-text {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.v2-welcome-greeting {
  margin: 0;
}

.v2-welcome-name {
  margin: 0;
  color: var(--v2-foreground);
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
